import flatten from 'lodash/fp/flatten'
import flow from 'lodash/fp/flow'
import map from 'lodash/fp/map'
import { useEffect, useState } from 'react'

export function useBowTieTypes(ships, scenarios, event) {
    const [data, setData] = useState({
        allDataBowtie: [],
        TYPEOPTIONS: {}
    })
    const [state, setState] = useState({ shipId: '', title: '', event: {}, scenarios: {} })
    const OBJS = []

    useEffect(() => {
        if (ships && scenarios && event) {
            const { siteId } = event
            const title = ships.filter((e, i) => e.title.replace(' ', '') === siteId)[0]?.title

            setState({
                shipId: title?.replace(' ', ''),
                title,
                scenarios,
                event
            })
        }
    }, [ships, scenarios, event])

    useEffect(() => {
        // Main types
        let drilling = 0
        let emergency = 0
        let operation = 0
        let maritime = 0
        let drillingThreats = 0 // Ameaças
        let drillingPrevention = 0 // Total de barreiras das Ameaças
        let drillingRecovery = 0 // Total de barreiras das consequências
        let drillingOutcome = 0 // Consequências
        let drillingDeprecated = 0 // Total de barreiras degradadas nas Ameaças e nas Consequências
        let drillingTotal = 0 // Total de barreias das Aemaças somdadas ao total de barreiras das Consequências
        const drillingMahDegraded = []
        let emergencyThreats = 0
        let emergencyPrevention = 0
        let emergencyRecovery = 0
        let emergencyOutcome = 0
        let emergencyDeprecated = 0
        let emergencyTotal = 0
        const emergencyMahDegraded = []
        let operationThreats = 0
        let operationPrevention = 0
        let operationRecovery = 0
        let operationOutcome = 0
        let operationDeprecated = 0
        let operationTotal = 0
        const operationMahDegraded = []
        let maritimeThreats = 0
        let maritimePrevention = 0
        let maritimeRecovery = 0
        let maritimeOutcome = 0
        let maritimeDeprecated = 0
        let maritimeTotal = 0
        const maritimeMahDegraded = []

        const hazards = (state?.scenarios && state?.scenarios[state?.shipId]) || {}

        OBJS.splice(0) // garante a remoção de todos objetos de resumo do card
        Object.keys(hazards)?.map(h => {
            const hazard = hazards[h]

            const id = hazard.id
            const key = hazard.key
            const title = hazard.label
            const type = hazard.type
            const threats = hazard && hazard.threats && hazard.threats?.length
            const consequences = hazard && hazard.consequences && hazard.consequences?.length

            let THR_Barriers = 0 // Total de barreiras das Ameaças(Threats)
            let CNQ_Barriers = 0 // Total de barreiras das Consequências()
            let order = 0

            const threatsFather = flow(map('children'), flatten)(hazard.threats)

            const threatsTotal = [...threatsFather]

            const consequencesFather = flow(map('children'), flatten)(hazard.consequences)

            const consequencesTotal = [...consequencesFather]

            let threatsDeprecated = event?.bowTie
                ?.map(row => {
                    if (row?.bowtieId === id) {
                        return row?.threats
                            ?.map(thr => {
                                return thr?.barriers?.filter(thr => thr.degraded)
                            })
                            .flat()
                            .filter(el => el)
                    }
                })
                .flat()
                .filter(el => el)

            let consequencesDeprecated = event?.bowTie
                ?.map(row => {
                    if (row?.bowtieId === id) {
                        return row?.consequences
                            ?.map(cnq => {
                                return cnq?.barriers?.filter(cnq => cnq.degraded)
                            })
                            .flat()
                            .filter(el => el)
                    }
                })
                .flat()
                .filter(el => el)

            threatsDeprecated = threatsDeprecated?.length
            consequencesDeprecated = consequencesDeprecated?.length

            const mahDegraded = {
                id: id,
                degraded: !!(threatsDeprecated + consequencesDeprecated)
            }

            hazard &&
                hazard.threats &&
                hazard.threats?.map(thr => {
                    THR_Barriers += (thr && thr.children && thr.children?.length) || 0
                })
            hazard &&
                hazard.consequences &&
                hazard.consequences?.map(cnq => {
                    CNQ_Barriers += (cnq && cnq.children && cnq.children?.length) || 0
                })

            if (type === 'drilling') {
                drillingMahDegraded.push(mahDegraded)
                order = drilling
                drilling += 1
                drillingThreats += threats
                drillingPrevention += THR_Barriers
                drillingRecovery += CNQ_Barriers
                drillingOutcome += consequences
                drillingDeprecated += threatsDeprecated + consequencesDeprecated
                drillingTotal += threatsTotal?.length + consequencesTotal?.length
            }
            if (type === 'emergency') {
                emergencyMahDegraded.push(mahDegraded)
                order = emergency
                emergency += 1
                emergencyThreats += threats
                emergencyPrevention += THR_Barriers
                emergencyRecovery += CNQ_Barriers
                emergencyOutcome += consequences
                emergencyDeprecated += threatsDeprecated + consequencesDeprecated
                emergencyTotal += threatsTotal?.length + consequencesTotal?.length
            }
            if (type === 'operation') {
                operationMahDegraded.push(mahDegraded)
                order = operation
                operation += 1
                operationThreats += threats
                operationPrevention += THR_Barriers
                operationRecovery += CNQ_Barriers
                operationOutcome += consequences
                operationDeprecated += threatsDeprecated + consequencesDeprecated
                operationTotal += threatsTotal?.length + consequencesTotal?.length
            }
            if (type === 'maritime') {
                maritimeMahDegraded.push(mahDegraded)
                order = maritime
                maritime += 1
                maritimeThreats += threats
                maritimePrevention += THR_Barriers
                maritimeRecovery += CNQ_Barriers
                maritimeOutcome += consequences
                maritimeDeprecated += threatsDeprecated + consequencesDeprecated
                maritimeTotal += threatsTotal?.length + consequencesTotal?.length
            }

            const OBJ = {
                id,
                title,
                type,
                key,
                status: event?.bowTie?.filter((e, i) => e?.bowtieId == h)[0]?.bowtieStatus,
                bowtieFrequency: event?.bowTie?.filter((e, i) => e?.bowtieId == h)[0]?.bowtieFrequency,
                order,
                hazard,
                threats_count: threats,
                consequences_count: consequences,
                threats_barriers: THR_Barriers,
                consequences_barriers: CNQ_Barriers,
                threatsDeprecated,
                consequencesDeprecated,
                barriersDeprecated: threatsDeprecated + consequencesDeprecated,
                barriersTotal: threatsTotal?.length + consequencesTotal?.length
            }

            OBJS.push(OBJ)
        })

        const TYPEOPTIONS = {
            drilling: {
                drillingMahDegraded: drillingMahDegraded,
                threats: drillingThreats, // Ameaças
                prevention: drillingPrevention, // Total de barreiras das Ameaças
                recovery: drillingRecovery, // Total de barreiras da Consequêcias
                outcome: drillingOutcome, // Consequências
                total: drillingTotal, // Total de barreias das Ameaças somadas ao total de barreiras das consequências
                deprecated: isNaN(drillingDeprecated) ? 0 : drillingDeprecated, // Total de barreiras degradadas nas Ameaças e nas Consequências
                percent:
                    drillingTotal && !isNaN(drillingDeprecated)
                        ? Math.floor(100 - (drillingDeprecated * 100) / drillingTotal)
                        : 100,
                bowtieList: OBJS?.filter(el => el?.type == 'drilling')
            },
            maritime: {
                maritimeMahDegraded: maritimeMahDegraded,
                threats: maritimeThreats,
                prevention: maritimePrevention,
                recovery: maritimeRecovery,
                outcome: maritimeOutcome,
                total: maritimeTotal,
                deprecated: isNaN(maritimeDeprecated) ? 0 : maritimeDeprecated,
                percent:
                    maritimeTotal && !isNaN(maritimeDeprecated)
                        ? Math.floor(100 - (maritimeDeprecated * 100) / maritimeTotal)
                        : 100,
                bowtieList: OBJS?.filter(el => el?.type == 'maritime')
            },
            operation: {
                operationMahDegraded: operationMahDegraded,
                threats: operationThreats,
                prevention: operationPrevention,
                recovery: operationRecovery,
                outcome: operationOutcome,
                total: operationTotal,
                deprecated: isNaN(operationDeprecated) ? 0 : operationDeprecated,
                percent:
                    operationTotal && !isNaN(operationDeprecated)
                        ? Math.floor(100 - (operationDeprecated * 100) / operationTotal)
                        : 100,
                bowtieList: OBJS?.filter(el => el?.type == 'operation')
            },
            emergency: {
                emergencyMahDegraded: emergencyMahDegraded,
                threats: emergencyThreats,
                prevention: emergencyPrevention,
                recovery: emergencyRecovery,
                outcome: emergencyOutcome,
                total: emergencyTotal,
                deprecated: isNaN(emergencyDeprecated) ? 0 : emergencyDeprecated,
                percent:
                    emergencyTotal && !isNaN(emergencyDeprecated)
                        ? Math.floor(100 - (emergencyDeprecated * 100) / emergencyTotal)
                        : 100,
                bowtieList: OBJS?.filter(el => el?.type == 'emergency')
            }
        }

        setData({ ...data, TYPEOPTIONS, allDataBowtie: OBJS })
    }, [state])

    return data
}
